module.exports = __webpack_public_path__ + "img/11087932_L.d2db04fe.png";